<template>
  <div>
    <h2 class="label mb10">{{locale.pidtype}}</h2>
    <div class="add">
      <input type="text" class="input"
        v-model="newPidType"
        @keyup.enter="add" />
      <button type="submit" class="btn"
        @click="add">
        {{locale.add}}
      </button>
    </div>
    <p v-if="isExist" class="colorRed mt5">{{locale.admin_pidtype_exist}}</p>
    <p v-if="pidType.list.length === 0" class="noData">{{locale.pidtype_nodata}}</p>
    <div v-else>
      <div class="mt30">
        <span class="checkbox">
          <input type="checkbox" id="required_edit_pidtype" v-model="pidType.requiredEdit">
          <label for="required_edit_pidtype">{{locale.required_check_edit}}</label>
        </span>
      </div>
      <table class="table mt15">
        <tbody>
          <tr v-for="pid in pidType.list" :key="pid.id">
            <Item
              :locale="locale"
              :pid="pid"
              :existPid="existPid"
              @delItem="deleteItem" />
          </tr>
        </tbody>
      </table>
    </div>
    <button type="button" class="btn btnFull btnPrimary mt15"
      @click="setPidType">
      {{locale.save}}
    </button>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import UNIQUE from '@/common/unique'
import regExp from '@/common/regExp'
import Item from '@/components/Admin/PidTypeItem.vue'

export default {
  name: 'PidType',
  props: [
    'locale'
  ],
  components: {
    Item
  },
  computed: {
    labelList () {
      return this.pidType.list ? this.pidType.list.map(x => x.label) : []
    },
    existPid () {
      const pidType = this.pidType.list
      const existFilter = pidType.filter((x, index) => pidType.findIndex(c => x.label === c.label) !== index).map(x => x.label)
      return existFilter
    },
    isExist () {
      const list = this.labelList
      return list.includes(this.newPidType)
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      newPidType: '',
      pidType: {
        list: [],
        requiredEdit: false
      }
    }
  },
  methods: {
    init () {
      this.newPidType = ''
      this.$store.dispatch('admin/getPidType').then((res) => {
        if (res) {
          if (Array.isArray(res)) {
            res = {
              list: res,
              requiredEdit: false
            }
          }
          this.pidType = res
        }
      })
    },
    add () {
      if (regExp.replaceAllEmpty(this.newPidType).length > 0) {
        const item = {
          id: UNIQUE.mid(),
          label: this.newPidType
        }
        this.pidType.list.push(item)
        this.newPidType = ''
      }
    },
    deleteItem (id) {
      this.pidType.list = this.pidType.list.filter(x => x.id !== id)
      this.setPidType()
    },
    setPidType () {
      const pidType = this.pidType
      this.$store.dispatch('admin/setPidType', pidType).then((res) => {
        if (res) {
          alert(this.locale.complete_save)
          this.init()
        } else {
          alert(this.locale.unknown_error)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.add {
  position: relative;
  .btn {
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
  }
  .input {
    padding-right: 130px;
  }
}
.btn.disabled {
  opacity: 0.7;
  cursor: not-allowed;
}
.noData {
  padding: 80px 0;
  text-align: center;
  font-size: 1.4em;
}
</style>
